const zipCodeMask = () => {
    let i;
    const maskArray = [];
    for (i = 0; i < 5; i++) {
      maskArray.push(/[0-9]/);
    }
    return maskArray;
  };
  
  export default zipCodeMask;